import { ThemeProvider } from "@emotion/react";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { createTheme } from "@mui/material";
import { useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Dashboard from "./Dashboard";
import Login from "./Login";
import "./Components/Animations.css";

// THEME
const theme = createTheme({
  palette: {
    primary: {
      main: "#0B1C4E",
      text: "white",
    },
    secondary: {
      main: "#EA8100",
      text: "rgb(80,80,80)",
    },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          "& label.Mui-focused": {
            color: "#0B1C4E",
          },
          "& label": {
            color: "#0B1C4E",
          },
          "& .MuiOutlinedInput-root": {
            color: "#0B1C4E",
            "& fieldset": {
              borderColor: "#0B1C4E",
            },
            "&:hover fieldset": {
              borderColor: "#0B1C4E",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#0B1C4E",
            },
          },
        },
      },
    },
  },
});

// ROUTER COMPONENT
export default function Router() {
  const [authToken, setAuthToken] = useState(localStorage.getItem("authToken"));

  const on_login = (user) => {
    // Set the token in local storage upon successful login
    const token = `p8joiasdfo203478posdaf${user.split("").join("as297djlz1")}23489pasdfl3knzv9a`;
    localStorage.setItem("authToken", token);
    setAuthToken(token);
  };

  const on_logout = () => {
    // Clear the token from local storage and state
    localStorage.removeItem("authToken");
    setAuthToken(null);
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={authToken ? <Navigate to="/dashboard" replace={true} /> : <Login on_login={on_login} />} />
            <Route path="/dashboard" element={authToken ? <Dashboard on_logout={on_logout} /> : <Navigate to="/login" />} />
            <Route path="/*" element={authToken ? <Navigate to="/dashboard" replace={true} /> : <Navigate to="/login" />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </>
  );
}
